import { CONVERSATION_PAGE_ANCHOR } from '../constants';
import { UnifiedThemeTableSection } from './unified-theme.table-section';

import { useSelectedSavedQuery } from '@/shared/hooks/use-selected-saved-query';
import { useSharedDateRange } from '@/shared/hooks/use-shared-date-range';

export function ThemeSection() {
  const { query: selectedQuery } = useSelectedSavedQuery();
  const { dateRange } = useSharedDateRange();

  return (
    <div className="space-y-6 p-6">
      <div data-anchor={CONVERSATION_PAGE_ANCHOR.POSITIVE_THEME_SECTION}>
        <UnifiedThemeTableSection
          startDate={dateRange.startDate}
          endDate={dateRange.endDate}
          queryId={selectedQuery.id}
        />
      </div>
    </div>
  );
}
